import { UserDc } from "./user-dc";

export class CustomerSession {
    public isLogin: boolean;
    public userId: Number;
    public userName: string;
    public loginName: string;
    public userType: string;
    public userTypeId: Number;
    public authenticationId: Number;
    public customerPortal: number;
    public userDc: UserDc;
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/models/login/customer-session.ts